import { render } from "./P084.vue?vue&type=template&id=13298a62&scoped=true"
import script from "./P084.vue?vue&type=script&lang=js"
export * from "./P084.vue?vue&type=script&lang=js"

import "./P084.vue?vue&type=style&index=0&id=13298a62&scoped=true&lang=css"

import exportComponent from "/home/sage/workspace/sageprice-dev/node_modules/vue-loader/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render],['__scopeId',"data-v-13298a62"]])

export default __exports__